import ProjectsSkeleton from '../../Components/loading-skeletons/projects-skeleton';

function Test() {
  return (
    <div>
      <ProjectsSkeleton />
    </div>
  );
}

export default Test;
